<template>
<div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
        <app-sidebar></app-sidebar>
        <div id="page-content-wrapper" style="width:100%">
            <i class="material-icons" id="menu-toggle" @click="isSidebar = !isSidebar">view_headline</i>
            <app-navbar></app-navbar>
            <div class="container-fluid mt-5" id="grad1">
                <!-- breadcrumb and title row starts -->
                <div class="row">
                    <div class="col-sm-12 print-scr">
                        <vs-breadcrumb align="left" :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/program-officer/todoList'
                  },

                  {
                    title: 'Event Wizard',

                  },
                   {
                    title: ` ${updateTraining.title} ${formatDateRange(updateTraining.startdate, updateTraining.enddate)}`,
                    active: true,
                    class: 'font-bold'
                  }
                ]"></vs-breadcrumb>
                    </div>
                    <div class="col-sm-12">
                        <div class="heading mt-3">
                            <h3 class="text-secondary">Event Wizard</h3>
                        </div>
                    </div>
                </div>
                <!-- breadcrumb and title row Ends -->
                <div class="row justify-content-center mt-0">
                    <div class="col-11 text-center p-0 mt-3 mb-2">
                        <div class="card px-0 pb-0 mt-3 mb-3">
                            <div class="row">
                                <div class="col-md-12 mx-0">
                                    <form id="msform">
                                        <!-- progressbar -->
                                        <ul id="progressbar">
                                            <li title="Warning! You are not authorized to access." id="NewTraining">
                                                <strong>Event Assignment</strong>
                                            </li>
                                            <li title="Warning! You are not authorized to access." id="PoAssignment">
                                                <strong>P.O Assignment</strong>
                                            </li>
                                            <li @click="trainingInformation()" class="completed" id="TrainingInformation">
                                                <strong>Event Information</strong>
                                            </li>
                                            <li @click="trainerRegistration()" class="completed" id="TrainerRegistration">
                                                <strong>Facilitators' Registration</strong>
                                            </li>
                                            <li class="active" id="TrainingAgenda">
                                                <strong>Event Agenda</strong>
                                            </li>
                                            <li @click="trainingMaterial()" id="Trainingmaterial">
                                                <strong>Upload Material</strong>
                                            </li>
                                            <li @click="trainingAssessment()" id="TrainingAssessments">
                                                <strong>Assessments</strong>
                                            </li>

                                            <li @click="traineeReg()" id="TraineeRegistration">
                                                <strong>Participants' Registration</strong>
                                            </li>
                                            <li @click="assessmentReviewFunction()" id="AssessmentReview">
                                                <strong>Review</strong>
                                            </li>
                                            <li @click="trainingCompletion()" id="Completion">
                                                <strong>Completion</strong>
                                            </li>
                                        </ul>
                                        <!-- fieldsets -->
                                        <fieldset style="text-align: left;padding: 30px;">
                                            
                                            <div class="row">
                                               <div class="col-md-6"> <h5>Event Agenda</h5> </div>
                                                                                <div class="col-md-6 text-right print-scr">
                                                                                    <router-link :to="{
                                                path:
                                                  '/dashboard/programOfficer/trainer-registration',
                                                query: {
                                                  trainingId: this.trainingCode
                                                }
                                              }" class="btn btn-primary btn-sm m-1">Previous Step</router-link>
                                                                                    <router-link :to="{
                                                path:
                                                  '/dashboard/programOfficer/wizardUploadMaterial',
                                                query: {
                                                  trainingId: this.trainingCode
                                                }
                                              }" class="btn btn-primary btn-sm">Next Step</router-link>
                                                                                </div>
                                                                            </div>
       
                                            <!-- row 1 starts  -->
                                            <div class="container-fluid">
                                                
                                                <vs-tabs class="custom-tabs" alignment="left" style="margin-bottom:10px">
                                                    <template v-if="foundAgenda == '' && editForm == false">
                                                        <form @submit.prevent="addAgenda">
                                                            <div class="col-sm-12 p-0">
                                                                <div class="alert alert-success" v-if="success">
                                                                    {{ success }}
                                                                </div>

                                                                <div class="alert alert-danger" v-for="error in errors" :key="error">
                                                                    <b>Please correct the following error(s):</b>
                                                                    {{ error }}
                                                                </div>

                                                                <!-- block 1 ends -->
                                                                <!-- block 2 starts -->
                                                                <div class="form-group form-row text-dark">
                                                                    <div class="row col-sm-12">
                                                                        <b-tabs content-class="mt-3 col-xl-12">
                                                                            <b-tab v-for="(item, index) in agendaArr" :key="index" :title="'Day ' + item.day">
                                                                                <!-- <div class="table-responsive"> -->
                                                                                <div class="col-sm-12 p-0" style="margin-bottom: 100px;">
                                                                                    <table class="table">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    Agenda Title
                                                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                                                </th>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    Assign Trainer
                                                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                                                </th>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    Session
                                                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                                                </th>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    Start Time
                                                                                                    <span style="color:rgba(255, 0, 0, 0.78);">*</span>
                                                                                                </th>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    End Time
                                                                                                </th>
                                                                                                <th scope="col"></th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            <!-- <template> -->
                                                                                            <tr v-for="(item, i) in item.data" :key="i">
                                                                                                <td>
                                                                                                    <div>
                                                                                                        <input style="box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" class="form-control" id="inputtext" v-model="item.title" placeholder autocomplete="off" />
                                                                                                    </div>
                                                                                                </td>
                                                                                                <td class="selectize-control single" style="width: 200px;">
                                                                                                    <selectize id="select-state" v-model="item.user_id" :settings="
                                                        provinceSetting
                                                      " :searchable="true">
                                                                                                        <option class="option" v-for="(itemnew,
                                                        index) in valuesArray" :key="index" :value="
                                                          itemnew.trainer
                                                            .trainer_id_user
                                                        " :text="
                                                          itemnew.trainer
                                                            .trainer_user_id
                                                            .name
                                                        ">
                                                                                                            {{
                                                        itemnew.trainer
                                                        .trainer_user_id
                                                        .name
                                                        }}
                                                                                                        </option>
                                                                                                    </selectize>
                                                                                                </td>
                                                                                                <td style="width: 150px;">
                                                                                                    <div>
                                                                                                        <input style="box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="number" class="form-control" v-model="item.session" id="inputtext" placeholder autocomplete="off" />
                                                                                                    </div>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <div>
                                                                                                        <flat-pickr class="form-control" style="background: #fff" placeholder v-model="item.fromtime" :config="timeOptions" autocomplete="off"></flat-pickr>
                                                                                                    </div>
                                                                                                </td>
                                                                                                <td>
                                                                                                    <div>
                                                                                                        <flat-pickr class="form-control" style="background: #fff" placeholder v-model="item.totime" :config="timeOptions" autocomplete="off"></flat-pickr>
                                                                                                    </div>
                                                                                                </td>

                                                                                                <td style="vertical-align: middle;">
                                                                                                    <div>
                                                                                                        <template v-if="i === 0">
                                                                                                            <span @click="
                                                            addRows(index)
                                                          ">
                                                                                                                <vs-icon icon="add_box" class="add-btn"></vs-icon>
                                                                                                            </span>
                                                                                                        </template>
                                                                                                        <template v-else>
                                                                                                            <span @click="
                                                            removeRow(index)
                                                          ">
                                                                                                                <vs-icon icon="delete_forever" class="delete-btn"></vs-icon>
                                                                                                            </span>
                                                                                                        </template>
                                                                                                    </div>
                                                                                                </td>
                                                                                            </tr>
                                                                                            <!-- </template> -->
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                                <!-- </div> -->
                                                                            </b-tab>
                                                                        </b-tabs>
                                                                        <!-- </template> -->
                                                                    </div>
                                                                </div>
                                                                <!-- block 2 ends -->
                                                                <!-- save button starts-->
                                                                <div class="row">
                                                                    <div class="col-md-12 text-right">
                                                                        <b-button type="submit" class="btn btn-primary btn-sm m-1" variant="primary">Save & Next Step</b-button>
                                                                    </div>
                                                                </div>

                                                                <!-- save button ends -->
                                                            </div>
                                                        </form>
                                                    </template>
                                                    <template v-else-if="foundAgenda != '' && editForm == false">
                                                        <div class="col-md-12 text-right mt-2">
                                                            <button class="btn btn-primary text-capitalize btn-report mr-1" @click="print">
                                                                Print Agenda
                                                            </button>
                                                        </div>
                                                        <div class="col-sm-12 p-0 mt-2 new_design">
                                                            <b-card class="mt-2 new_design">
                                                                <div class="form-group new_design">
                                                                    <div class="row new_design">
                                                                        <div class="col-sm-12 p-0">
                                                                            <!-- <div class="table-responsive"> -->
                                                                            <div class="mb-1" style="float:left" v-if="isDateValid">
                                                                                <b-button variant="outline-primary" @click="
                                              EditAgenda(updateTraining.id)
                                            " class="mr-1 edit-button" size="sm">Edit</b-button>
                                                                                <b-button variant="outline-danger" class="mr-1 delete-button" size="sm" @click="
                                              DeleteAgenda(updateTraining.id)
                                            ">Delete</b-button>
                                                                            </div>
                                                                            <br />
                                                                           
                                                                            <div id="printMe" class="print_table_area p-3">
                                                                                <div class="row">
                                                                                    <div class="col-md-4">
                                                                                        <img :src=" basepath + '/unodc_logo.png'" alt width="200" />
                                                                                    </div>
                                                                                    
                                                                                    
                                                                                </div>
                                                                                <div class="table-responsive row col-md-12">
                                                                                    <table class="table table-striped" id="display" style="width:100%">
                                                                                        <tr class="p_title">
                                                                                            <td colspan="3">
                                                                                                <b>
                                                                                                    {{updateTraining.title}}
                                                                                                </b>
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan="3">
                                                                                                {{updateTraining.startdate}}
                                                                                                , {{ updateTraining.enddate }}
                                                                                            </td>
                                                                                        </tr>

                                                                                        <tbody v-for="(agenda,) in foundAgenda" :key="agendaIndex">
                                                                                            <tr v-if="agenda.user != null">
                                                                                                <td>
                                                                                                    Day {{ agenda.days }} :
                                                                                                    {{ agenda.fromtime }} -
                                                                                                    {{ agenda.totime }}
                                                                                                </td>
                                                                                                <td class="text-capitalize">
                                                                                                    {{ agenda.title }}
                                                                                                </td>

                                                                                                <td class="text-capitalize" v-if="agenda.user != null">
                                                                                                    {{ agenda.user.name }}
                                                                                                </td>
                                                                                                <td v-else>N/A</td>
                                                                                            </tr>
                                                                                            <tr class="p_break" style="background:#d8ba25d4" v-else>
                                                                                                <td>
                                                                                                    Day {{ agenda.days }} :
                                                                                                    {{ agenda.fromtime }} -
                                                                                                    {{ agenda.totime }}
                                                                                                </td>
                                                                                                <td class="text-capitalize">
                                                                                                    {{ agenda.title }}
                                                                                                </td>

                                                                                                <td class="text-capitalize" v-if="agenda.user != null">
                                                                                                    {{ agenda.user.name }}
                                                                                                </td>
                                                                                                <td v-else>N/A</td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </div>
                                                                            </div>
                                                                            <div class="table-responsive">
                                                                                <table class="table tbl-border" id="display" style="width:100%">
                                                                                    <tr>
                                                                                        <th>Day</th>
                                                                                        <th>Session #</th>
                                                                                        <th>Title</th>
                                                                                        <th>Assigned To</th>
                                                                                        <th>Event Title</th>
                                                                                        <th>From Time</th>
                                                                                        <th>To Time</th>
                                                                                        <th>Created on</th>
                                                                                    </tr>
                                                                                    <tbody>
                                                                                        <tr v-for="(agenda,agendaIndex) in foundAgenda" :key="agendaIndex">
                                                                                            <td>{{ agenda.days }}</td>
                                                                                            <td class="text-capitalize">
                                                                                                {{ agenda.session }}
                                                                                            </td>
                                                                                            <td class="text-capitalize">
                                                                                                {{ agenda.title }}
                                                                                            </td>
                                                                                            <td class="text-capitalize" v-if="agenda.user != null">
                                                                                                {{ agenda.user.name }}
                                                                                            </td>
                                                                                            <td v-else>N/A</td>
                                                                                            <td class="text-capitalize">
                                                                                                {{ agenda.training.title }}
                                                                                            </td>
                                                                                            <td class="text-capitalize">
                                                                                                {{ agenda.fromtime }}
                                                                                            </td>
                                                                                            <td class="text-capitalize">
                                                                                                {{ agenda.totime }}
                                                                                            </td>
                                                                                            <td>
                                                                                                {{agenda.createdAt | formatDate}}
                                                                                            </td>
                                                                                        </tr>
                                                                                    </tbody>
                                                                                </table>
                                                                            </div>
                                                                            <!-- </div> -->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </b-card>

                                                            <!-- new form popup ends -->
                                                        </div>
                                                    </template>
                                                    <template v-if="editForm == true">
                                                        <form @submit.prevent="updateagenda">
                                                            <div class="col-sm-12 p-0">
                                                                <div class="form-group form-row text-dark">
                                                                    <div class="row col-sm-12">
                                                                        <b-tabs content-class="mt-3 col-xl-12">
                                                                            <b-tab v-for="(item, index) in agendaArr" :key="index" :title="'Day ' + item.day">
                                                                                <div class="col-sm-12" style="margin-bottom: 150px;">
                                                                                    <table class="table">
                                                                                        <thead>
                                                                                            <tr>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    Agenda Title
                                                                                                </th>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    Assign Trainer
                                                                                                </th>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    Session
                                                                                                </th>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    Start Time
                                                                                                </th>
                                                                                                <th scope="col" style="color: #07a7e19c !important;">
                                                                                                    End Time
                                                                                                </th>
                                                                                                <th scope="col"></th>
                                                                                            </tr>
                                                                                        </thead>
                                                                                        <tbody>
                                                                                            <template>
                                                                                                <tr v-for="(item,
                                                    i) in item.data" :key="i">
                                                                                                    <td>
                                                                                                        <div>
                                                                                                            <input style="box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="text" class="form-control" id="inputtext" v-model="item.title" placeholder />
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td style="width:300px">
                                                                                                        <selectize id="select-state" v-model="item.user_id" :settings="
                                                          provinceSetting
                                                        " :searchable="true">
                                                                                                            <option v-for="(itemnew,
                                                          index) in valuesArray" :key="index" :value="
                                                            itemnew.trainer
                                                              .trainer_id_user
                                                          " :text="
                                                            itemnew.trainer
                                                              .trainer_user_id
                                                              .name
                                                          ">
                                                                                                                {{
                                                          itemnew.trainer
                                                          .trainer_user_id
                                                          .name
                                                          }}
                                                                                                            </option>
                                                                                                        </selectize>
                                                                                                    </td>
                                                                                                    <td style="width: 150px;">
                                                                                                        <div>
                                                                                                            <input style="box-shadow: none !important;calc(1.3em + 0.75rem + 2px)" type="number" class="form-control" v-model="item.session" id="inputtext" placeholder />
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <div>
                                                                                                            <flat-pickr class="form-control" style="background: #fff" placeholder v-model="
                                                            item.fromtime
                                                          " :config="timeOptions"></flat-pickr>
                                                                                                        </div>
                                                                                                    </td>
                                                                                                    <td>
                                                                                                        <div>
                                                                                                            <flat-pickr class="form-control" style="background: #fff" placeholder v-model="item.totime" :config="timeOptions"></flat-pickr>
                                                                                                        </div>
                                                                                                    </td>

                                                                                                    <td style="vertical-align: middle;margin-top:0px">
                                                                                                        <div>
                                                                                                            <template v-if="i === 0">
                                                                                                                <span @click="
                                                              addRows(index)
                                                            ">
                                                                                                                    <vs-icon icon="add_box" class="add-btn"></vs-icon>
                                                                                                                </span>
                                                                                                            </template>
                                                                                                            <template v-else>
                                                                                                                <span @click="
                                                              removeRow(index)
                                                            ">
                                                                                                                    <vs-icon icon="delete_forever" class="delete-btn"></vs-icon>
                                                                                                                </span>
                                                                                                            </template>
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </tr>
                                                                                            </template>
                                                                                        </tbody>
                                                                                    </table>
                                                                                    <!-- </div> -->
                                                                                </div>
                                                                            </b-tab>

                                                                            <b-button class="btn-primary btn-sm m-1" @click="closeEditForm" variant="primary">Cancel</b-button>
                                                                            <b-button type="submit" class="btn btn-primary btn-sm m-1" variant="primary">Update</b-button>
                                                                        </b-tabs>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </template>
                                                </vs-tabs>
                                            </div>

                                            <!-- Next Step Button Ends  -->
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div></div>
</div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";
import selectize from "vue2-selectize";
import "bootstrap/dist/css/bootstrap.css";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {formatDateRange} from "../../../utils/DateFormate";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
export default {
    data: () => ({
        success: "",
        errors: [],
        foundAgenda: [],
        updateAgenda: [],
        editForm: false,
        isempty: true,
        basepath: process.env.VUE_APP_BASE_PATH,
        updateTraining: [],
        isSidebar: false,
        valuesArray: [],
        timeOptions: {
            enableTime: true,
            noCalendar: true,
            dateFormat: "H:i",
            minTime: "08:00",
        },
        dynamicTabs: 1,
        updateDynamictabs: "",
        tabOptions: [
            // {text:"Select no of Days",value:0},
            {
                text: 1,
                value: 1
            },
            {
                text: 2,
                value: 2
            },
            {
                text: 3,
                value: 3
            },
            {
                text: 4,
                value: 4
            },
            {
                text: 5,
                value: 5
            },
            {
                text: 6,
                value: 6
            },
            {
                text: 7,
                value: 7
            }
        ],
        checkBox1: true,
        checkBox2: false,
        checkBox3: false,
        days: 0,
        tableArr: 1,
        activeItem: 0,
        search: "",
        trainingId: "",
        trainingCode: "",
        noOfDays: "",
        trainerID: [],
        newArray: [],
        addArray: [],
        select2: 2,
        agendaArr: [{
            day: "1",
            data: [{
                session: "",
                fromtime: "",
                totime: "",
                title: "",
                user_id: ""
            }]
        }],
        provinceSetting: {
            maxItems: 1,
            searchField: ["text"],
            placeholder: "Select Trainer"
        },
        rowArr: [{
            session: "",
            fromtime: "",
            totime: "",
            title: "",
            user_id: ""
        }],
        options1: [{
                text: "1 Day",
                value: 1
            },
            {
                text: "2 Days",
                value: 1
            },
            {
                text: "3 Days",
                value: 2
            },
            {
                text: "4 Days",
                value: 3
            },
            {
                text: "5 Days",
                value: 4
            }
        ],
        trainerArr: [{
                text: "Dr. Umar Abdur Rahman",
                value: 1
            },
            {
                text: "Dr. Muhammad Abdur Rahman",
                value: 2
            },
            {
                text: "Brig Khalid Mahmood",
                value: 3
            }
        ],
        training_status: "",
        trainingEndDate: "",
        isDateValid: true,
    }),

    mounted() {
        axios.defaults.headers['Authorization'] = localStorage.getItem('token')
        this.trainingCode = this.$route.query.trainingId;
        this.openLoading();
        axios
            .get(
                process.env.VUE_APP_BASE_PATH +
                "/programOfficer/trainingsingle/get/" +
                this.trainingCode

            )
            .then(response => {
                if (response.data.unAuth) {
                    this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);

                }
                if (response.data.tokenExpired) {
                    this.$toasted.global.errorMsg(response.data.tokenExpired);
                    localStorage.clear();
                    setTimeout(() => {
                        this.$router.push("/");
                    }, 1000);
                }
                this.closeLoading();
                this.trainingId = response.data.training.id;
                this.training_status = response.data.training.trainingstatus;
                this.updateTraining = response.data.training;
                this.dynamicTabs = this.updateTraining.noofdays;
                this.trainingEndDate = response.data.training.enddate;
                //check the agenda s already created for this training
                this.allAgendas();
                this.getAllTrainers();
                this.dateCheck();
            });
    },

    components: {
        "app-navbar": Navbar,
        "app-sidebar": Sidebar,
        selectize,
        flatPickr
    },
    watch: {
        "agendaArr.data.fromtime": function () {
            //to work with changes in someOtherProp
            alert();
        },
        days(val) {
            this.tableArr = val + 1;
        },
        dynamicTabs(val) {
            this.agendaArr = [];
            for (var i = 0; i < val; i++) {
                this.agendaArr.push({
                    day: i + 1,
                    data: [{
                        session: "",
                        fromtime: "",
                        totime: "",
                        title: "",
                        user_id: ""
                    }]
                });
            }
        },
        updateDynamictabs(val) {
            if (val < this.noOfDays) {
                this.updateDynamictabs = this.noOfDays;
            } else {
                this.agendaArr = [];
                this.newArray.forEach(val => {
                    if (this.agendaArr.some(person => person.day === val.days)) {
                        this.dayIndex = this.agendaArr.map(e => e.day).indexOf(val.days);
                        this.agendaArr[this.dayIndex].data.push(val);
                    } else {
                        this.agendaArr.push({
                            day: val.days,
                            data: [val]
                        });
                    }
                });

                for (var i = 0 + this.noOfDays; i < val; i++) {
                    this.agendaArr.push({
                        day: this.agendaArr.length + 1,
                        data: [{
                            session: "",
                            fromtime: "",
                            totime: "",
                            title: "",
                            user_id: ""
                        }]
                    });
                }
            }
        }
    },
    methods: {
        formatDateRange,
        print() {
            // Pass the element id here
            this.$htmlToPaper("printMe");
        },
        PrintTrainingDetails: function () {
            window.print();
        },
        // onclick show wizard steps
        trainingInformation() {
            this.$router.push({
                path: "/dashboard/programOfficer/training-information",
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainerRegistration() {
            this.$router.push({
                path: "/dashboard/programOfficer/trainer-registration",
                query: {
                    trainingId: this.trainingCode
                }
            });
        },
        trainingMaterial() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/wizardUploadMaterial",
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },
        trainingAssessment() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg("Please complete all steps by clicking on Save & Next button")
            } else  {
                this.$router.push({
                    path: '/dashboard/programOfficer/training-assesment',
                    query: { trainingId: this.trainingCode }
                });
            } 
                
        },
        traineeReg() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/trainee-registration",
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },
        assessmentReviewFunction() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/assesment-review",
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },
        trainingCompletion() {
            if (this.training_status == "In Queue") {
                this.$toasted.global.errorMsg(
                    "Please complete all steps by clicking on Save & Next button"
                );
            } else {
                this.$router.push({
                    path: "/dashboard/programOfficer/wizard-completion",
                    query: {
                        trainingId: this.trainingCode
                    }
                });
            }
        },

        closeEditForm() {
            this.editForm = false;
            this.updateAgenda = [];

        },
        // this will show all trainers for the current training
        getAllTrainers: async function getAllTrainers() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/trainers/all/" +
                    this.trainingId +
                    "/get"

                )
                .then(async response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();

                    this.valuesArray = await response.data;
                });
        },
        allAgendas: function allAgendas() {
            this.openLoading();
            axios
                .get(
                    process.env.VUE_APP_BASE_PATH +
                    "/check/traninig/agenda/" +
                    this.trainingId

                )
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.foundagenda != null) {
                        this.foundAgenda = response.data.foundagenda;
                    } else {
                        this.foundagenda = "";
                    }
                });
        },
        DeleteAgenda(id) {
            let self = this;
            this.openLoading();
            axios
                .post(process.env.VUE_APP_BASE_PATH + "/training/agenda/delete", {
                    id: id
                })
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data.success) {
                        this.foundAgenda = "";
                        self.toastSuccess("Agenda has been deleted successfully!");
                    } else if (response.data.error) {
                        throw response.data.error;
                    }
                })
                .catch(error => {
                    self.toastError(error);
                });
        },
        EditAgenda(id) {
            this.openLoading();
            axios
                .post(process.env.VUE_APP_BASE_PATH + "/training/agenda/edit", {
                    id: id
                })
                .then(response => {
                    if (response.data.unAuth) {
                        this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);

                    }
                    if (response.data.tokenExpired) {
                        this.$toasted.global.errorMsg(response.data.tokenExpired);
                        localStorage.clear();
                        setTimeout(() => {
                            this.$router.push("/");
                        }, 1000);
                    }
                    this.closeLoading();
                    if (response.data) {
                        response.data.forEach(element => {
                            if (element) {
                                this.updateDynamictabs = response.data.length;
                                this.noOfDays = response.data.length;
                                this.newArray = response.data;
                            }
                        });
                    }
                    this.editForm = true;
                    this.updateAgenda = response.data;
                })
                .catch(error => {
                    self.toastError(error);
                });
        },
        toastSuccess(msg) {
            this.$bvToast.toast(msg, {
                title: "Success",
                autoHideDelay: 10000,
                variant: "success",
                solid: true
            });
        },
        toastError(msg) {
            this.$bvToast.toast(msg, {
                title: "Error",
                autoHideDelay: 10000,
                variant: "danger",
                solid: true
            });
        },
        openLoading() {
            this.$vs.loading({
                type: "material"
            });
        },
        closeLoading() {
            this.$vs.loading.close();
        },
        dateCheck() {
            const today = new Date();
            const dateString = this.trainingEndDate;
            const [day, month, year] = dateString.split("-");

            // Create a new date object for the target date
            const targetDate = new Date(`${year}-${month}-${day}`);

            // Add 3 days to the target date
            targetDate.setDate(targetDate.getDate() + 6);

            today.setHours(0, 0, 0, 0);
            targetDate.setHours(0, 0, 0, 0);

            // Compare today's date with the updated target date
            if (today > targetDate) {
                this.isDateValid = false;
            }

        },
        addAgenda(e) {
            e.preventDefault();
            this.errors = [];
            let self = this;
            this.isempty = true;
            if (this.agendaArr != undefined && this.agendaArr != null) {
                this.agendaArr.map((element, index) => {
                    element.data.map(val => {

                        if (val.session == "") {
                            this.$toasted.global.errorMsg("Day " + (index + 1) + " Session  is required.");
                            this.isempty = false;
                        }
                        if (val.title == "") {
                            this.$toasted.global.errorMsg("Day " + (index + 1) + " Title is required.");
                            this.isempty = false;
                        }
                    });
                });
            }
            if (this.isempty) {
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/register/addAgenda", {
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,

                        session: JSON.stringify(this.agendaArr),
                        trainingId: this.trainingId
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Agenda has been added successfully!");
                            self.foundAgenda = response.data;
                            self.resetForm();
                            this.$router.push({
                                name: "wizardUploadMaterial",
                                query: {
                                    trainingId: this.trainingCode
                                }
                            });
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.success = "";
                        self.error = error;
                    });
            } else {
                this.closeLoading();
            }

            // }
        },
        updateagenda(e) {
            e.preventDefault();
            this.errors = [];
            let self = this;
            this.isempty = true;
            if (this.agendaArr != undefined && this.agendaArr != null) {
                this.agendaArr.map((element, index) => {
                    element.data.map(val => {

                        if (val.session == "") {
                            this.$toasted.global.errorMsg("Day " + (index + 1) + " Session  is required.");
                            this.isempty = false;
                        }
                        if (val.title == "") {
                            this.$toasted.global.errorMsg("Day " + (index + 1) + " Title is required.");
                            this.isempty = false;
                        }
                    });
                });
            }
            if (this.isempty) {
                this.openLoading();
                axios
                    .post(process.env.VUE_APP_BASE_PATH + "/update/Agenda", {
                        user_id: JSON.parse(localStorage.getItem("currentUser")).id,
                        session: JSON.stringify(this.agendaArr),
                        trainingId: this.trainingId
                    })
                    .then(response => {
                        this.closeLoading();
                        if (response.data.success) {
                            self.toastSuccess("Agenda has been updated successfully!");
                            self.foundAgenda = response.data;
                            self.resetForm();
                            this.$router.push({
                                name: "wizardUploadMaterial",
                                query: {
                                    trainingId: this.trainingCode
                                }
                            });
                        } else if (response.data.error) {
                            throw response.data.error;
                        }
                    })
                    .catch(error => {
                        self.success = "";
                        self.error = error;
                    });
            } else {
                this.closeLoading();
            }
        },
        resetForm() {},
        addRows(val) {
            this.agendaArr[val].data.push({
                session: "",
                fromtime: "",
                totime: "",
                title: "",
                user_id: ""
            });
        },
        removeRow(val) {
            this.agendaArr[val].data.pop();
        },
        showForm() {
            this.isForm = false;
            this.isFormData = true;
        },
        successUpload() {
            this.$vs.notify({
                color: "success",
                title: "Upload Success",
                text: "Files have been Uploaded, consectetur"
            });
        }
    }
};
</script>

<style scoped>
.vs-breadcrumb {
    font-size: 18px !important;
    font-weight: 600 !important;
}

#grad1 {
    background-color: #fff;
}

.print_table_area {
    display: none;
}

#msform {
    text-align: center;
    position: relative;
    margin-top: 20px;
}

#msform fieldset .form-card {
    background: white;
    border: 0 none;
    border-radius: 0px;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    padding: 20px 40px 30px 40px;
    box-sizing: border-box;
    width: 94%;
    margin: 0 3% 20px 3%;
    position: relative;
}

#msform fieldset {
    padding: 10px;
    background: #e8e8e8;
    border: 0 none;
    border-radius: 2rem;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}

#msform fieldset:not(:first-of-type) {
    display: none;
}

#msform fieldset .form-card {
    text-align: left;
    color: #9e9e9e;
}

#progressbar .completed {
    color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
    background: #06a6e0;
}

#msform .action-button {
    width: 100px;
    background: skyblue;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
    width: 100px;
    background: #616161;
    font-weight: bold;
    color: white;
    border: 0 none;
    border-radius: 0px;
    cursor: pointer;
    padding: 10px 5px;
    margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
    box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
    border: none;
    outline: 0;
    border-bottom: 1px solid #ccc;
    padding: 2px 5px 3px 5px;
    margin: 2px;
}

select.list-dt:focus {
    border-bottom: 2px solid skyblue;
}

.card {
    z-index: 0;
    border: none;
    border-radius: 0.5rem;
    position: relative;
}

.fs-title {
    font-size: 25px;
    color: #2c3e50;
    margin-bottom: 10px;
    font-weight: bold;
    text-align: left;
}

.new_design {
    background: #e8e8e8;
}

#progressbar {
    margin-bottom: 30px;
    overflow: hidden;
    color: lightgrey;
}

#progressbar .active {
    color: #000000;
}

#progressbar li {
    list-style-type: none;
    font-size: 12px;
    width: 9.5%;
    text-align: center;
    float: left;
    position: relative;
}

#progressbar #NewTraining:before {
    content: "1";
}

#progressbar #PoAssignment:before {
    content: "2";
}

#progressbar #TrainingInformation:before {
    content: "3";
}

#progressbar #TrainerRegistration:before {
    content: "4a";
}

#progressbar #TrainingAgenda:before {
    content: "4b";
}

#progressbar #Trainingmaterial:before {
    content: "4c";
}

#progressbar #TrainingAssessments:before {
    content: "4d";
}

#progressbar #TraineeRegistration:before {
    content: "4e";
}

#progressbar #AssessmentReview:before {
    content: "5";
}

#progressbar #Completion:before {
    content: "6";
}

#progressbar li:before {
    width: 35px;
    height: 35px;
    line-height: 30px;
    display: block;
    font-size: 18px;
    color: #ffffff;
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
}

#progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 17px;
    z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
    background: #000000;
}

.radio-group {
    position: relative;
    margin-bottom: 25px;
}

.radio {
    display: inline-block;
    width: 204;
    height: 104;
    border-radius: 0;
    background: lightblue;
    box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    cursor: pointer;
    margin: 8px 2px;
}

.radio:hover {
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
    box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
    width: 100%;
    object-fit: cover;
}

.custom-tabs .vs-tabs--btn {
    font-size: large !important;
    padding: 10px 20px !important;
    font-weight: 500;
    margin: 0px 10px;

}

.custom-tabs .vs-tabs-primary .activeChild button,
.vs-tabs-primary:hover {
    color: none !important;
}

.custom-tabs .line-vs-tabs {
    display: none !important;
}

.custom-tabs .vs-tabs--ul {
    webkit-box-shadow: none !important;
    box-shadow: none !important;
}

@media print {
    .print_table_area {
        display: block;
    }

    .p_title {
        color: blue !important;
        font-size: 34px !important;
    }

    .p_break {
        background: #d8ba25d4 !important;
    }

    #page-content-wrapper {
         overflow: visible !important;
        height: auto !important;
    }

    .btn-report {
        display: none;
    }

    .print-media {
        display: none;
    }

    .print-scr {
        display: none;
    }

    #progressbar {
        display: none;
    }

    .delete-button,
    .edit-button {
        display: none;
    }

    #msform fieldset {
        border: none !important;
    }

    .tbl-border {
        background-color: grey !important;
    }
}

.selectize-control.multi .selectize-input>div {
    background: rgba(7, 167, 225, 0.61);
    color: #333333;
}

.con-select {
    font-size: 0.85rem !important;
    width: 100% !important;
}

.selectize-input.items.not-full.has-options.has-items {
    font-size: 0.85rem !important;
}
</style>
